
import { Category, ListingTier, Professional } from './types';

export const CATEGORIES = Object.values(Category);

export const STATES = ['VIC', 'NSW', 'QLD', 'WA', 'SA', 'TAS', 'ACT', 'NT'];

export const COUNCIL_INSIGHTS = [
  { name: 'City of Melbourne', permitRate: '82%', avgDays: '45', challenge: 'Heritage Controls' },
  { name: 'City of Sydney', permitRate: '78%', avgDays: '58', challenge: 'Density & Traffic' },
  { name: 'Brisbane City', permitRate: '89%', avgDays: '32', challenge: 'Flooding Overlays' },
  { name: 'City of Perth', permitRate: '85%', avgDays: '40', challenge: 'Sustainability' },
];

export const SUCCESS_STORIES = [
  { 
    id: 1, 
    title: 'Dual Occupancy Success', 
    location: 'Richmond, VIC', 
    summary: 'A complex heritage site turned into two modern townhouses with the help of PlanStack consultants.',
    image: 'https://images.unsplash.com/photo-1448630360428-65456885c650?auto=format&fit=crop&q=80&w=800'
  },
  { 
    id: 2, 
    title: 'Eco-Industrial Warehouse', 
    location: 'Alexandria, NSW', 
    summary: 'PlanStack ESD and Structural experts delivered a net-zero commercial space on budget.',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&q=80&w=800'
  }
];

// Seed data to ensure the Export functionality can be tested immediately
export const MOCK_PROFESSIONALS: Professional[] = [
  {
    id: 'pro-seed-001',
    businessName: 'PlanStack Elite Consulting',
    category: Category.TOWN_PLANNING,
    tier: ListingTier.EXCLUSIVE,
    rating: 5.0,
    reviewCount: 24,
    abn: '12 345 678 901',
    location: { 
      state: 'VIC', 
      suburb: 'Melbourne', 
      address: 'Level 10, 459 Collins Street',
      lat: -37.8136, 
      lng: 144.9631 
    },
    contact: { 
      email: 'admin@planstack.com.au', 
      phone: '03 9000 0000',
      website: 'https://planstack.com.au'
    },
    description: 'This is a premium seed listing used to verify directory synchronization and CSV export features. PlanStack Elite provides national coverage for complex residential and commercial developments.',
    tags: ['Verified', 'Seed Data', 'Test Listing', 'Elite'],
    imageUrl: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=1200',
    isVerified: true,
    createdAt: '2024-01-01T00:00:00.000Z'
  },
  {
    id: 'pro-seed-002',
    businessName: 'ArchiCore National',
    category: Category.ARCHITECTURE,
    tier: ListingTier.EXCLUSIVE,
    rating: 4.9,
    reviewCount: 42,
    abn: '98 765 432 109',
    location: { 
      state: 'NSW', 
      suburb: 'Sydney', 
      address: 'Suite 2, 100 George St',
      lat: -33.8688, 
      lng: 151.2093 
    },
    contact: { 
      email: 'sydney@archicore.com.au', 
      phone: '02 8000 0000',
      website: 'https://archicore.com.au'
    },
    description: 'Specializing in high-density residential and state-significant infrastructure projects across Australia.',
    tags: ['Verified', 'Architecture', 'Sydney', 'High Density'],
    imageUrl: 'https://images.unsplash.com/photo-1503387762-592dea58ef23?auto=format&fit=crop&q=80&w=1200',
    isVerified: true,
    createdAt: '2024-01-02T00:00:00.000Z'
  }
];

export const PRICING_PLANS = [
  { name: 'Basic Listing', price: 'Free', features: ['Business Name & Phone', '1 Category'], tier: ListingTier.FREE, highlight: false },
  { name: 'Featured Listing', price: '$49/mo', features: ['Priority Ranking', 'Website Link', 'Logo'], tier: ListingTier.FEATURED, highlight: false },
  { name: 'Premium Profile', price: '$149/mo', features: ['Top Results', 'Photo Gallery', 'SEO Boost'], tier: ListingTier.PREMIUM, highlight: true },
  { name: 'Elite Sponsorship', price: '$499/mo', features: ['Rotational Homepage Spotlight', 'Exclusive Council Banner', 'Direct Leads', 'Verified Status Badge'], tier: ListingTier.EXCLUSIVE, highlight: false }
];
